var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJwt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.127 13.238l1.084-1.135 1.083 1.135v4.679H9.127v-4.679z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39 12.107l1.544-.28.21 1.554-2.75 3.785-1.753-1.274 2.75-3.784z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 10.17l1.415.68-.745 1.382-4.45 1.445-.669-2.06 4.45-1.447z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19 8.17l.744 1.38-1.414.68-4.45-1.445.67-2.061L7.19 8.17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.802 6.867l-.21 1.555-1.543-.28L4.3 4.355l1.753-1.274 2.75 3.785z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.872 6.762L9.79 7.897 8.705 6.762V2.083h2.167v4.679z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.61 7.893l-1.544.281-.21-1.555 2.75-3.785 1.753 1.274-2.75 3.785z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 9.83l-1.415-.68.745-1.382 4.45-1.446.669 2.061-4.45 1.446z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 11.83l-.744-1.38 1.413-.68 4.45 1.445-.67 2.061-4.449-1.446z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.197 13.133l.21-1.555 1.544.28 2.75 3.786-1.754 1.274-2.75-3.785z"
  })));
}
export default SvgJwt;